export default {"src":"/_next/static/media/Footer_logo.39541377.svg","height":56,"width":224,"blurWidth":0,"blurHeight":0};